<template>
  <d2-container>
    <el-button
      class="filter-item"
      v-permission:function="['medalManger:btn_add']"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="getAdd"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="medalLsit"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{scope.row.id}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="icon">
        <template slot-scope="scope">
          <img :src="scope.row.icon" alt style="width:60px;height:60px" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.createTime}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="320">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            v-permission:function="['medalManger:btn_edit']"
            @click="editCard(scope.row.id)"
          >编辑</el-button>
          <el-button
            size="small"
            v-permission:function="['medalManger:btn_grant']"
            @click="getGrant(scope.row.id)"
            type="success"
          >发放</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
      <!-- 选择用户弹窗 -->
      <el-dialog
        title="选择用户"
        width="1732px"
        :visible.sync="dialogFormVisible "
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        @close="onCancel"
        @closed="closedFn"
      >
        <el-form label-width="120px" size="normal" ref="ruleForm" :inline="false" :model="form">
          <el-form-item label="选择用户：">
            <el-button type="primary" @click="openDialog()">选择用户</el-button>
            <el-button type="danger" @click="batchDelete()">批量删除</el-button>
            <!-- <div v-for="(item,index) in form.multipleSelection" :key="index"> -->
            <el-table
              size="small"
              :key="tableKey"
              :data="form.multipleSelection"
              ref="tableRef"
              stripe
              border
              highlight-current-row
              style=" margin-top: 20px"
            >
              <el-table-column align="center" label width="180" type="selection"></el-table-column>
              <el-table-column align="center" label="id" width="120">
                <template slot-scope="scope">
                  <span>{{scope.row.id}}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" align="center" label="靓号id">
                <template slot-scope="scope">
                  <span>{{scope.row.specificCode}}</span>
                </template>
              </el-table-column>
              <el-table-column width="270" align="center" label="注册时间">
                <template slot-scope="scope">
                  <span>{{scope.row.createTime}}</span>
                </template>
              </el-table-column>
              <el-table-column width="120" align="center" label="昵称">
                <template slot-scope="scope">
                  <span>{{scope.row.nickname}}</span>
                </template>
              </el-table-column>
              <el-table-column width="120" align="center" label="头像">
                <template slot-scope="scope">
                  <img :src="scope.row.avatar" style="width:80px;height:80px;object-fit: cover" />
                </template>
              </el-table-column>
              <el-table-column width="180" align="center" label="号码">
                <template slot-scope="scope">
                  <span>{{scope.row.mobile}}</span>
                </template>
              </el-table-column>
              <el-table-column width="120" align="center" label="总经验值">
                <template slot-scope="scope">
                  <span>{{scope.row.pointAmount || '无'}}</span>
                </template>
              </el-table-column>
              <el-table-column width="120" align="center" label="订单数">
                <!-- <template slot-scope="scope">
          <span>{{scope.row.maxPrice}}</span>
                </template>-->
              </el-table-column>
              <el-table-column width="120" align="center" label="订单经验值">
                <!-- <template slot-scope="scope">
          <span>{{scope.row.state == 1 ? '上架' : '下架'}}</span>
                </template>-->
              </el-table-column>
              <el-table-column width="120" align="center" label="等级">
                <template slot-scope="scope">
                  <span>{{scope.row.levelName}}</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- </div> -->
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onDetermine">确 定</el-button>
        </div>
      </el-dialog>
      <users :visible.sync="dlGoodsShow" :select-list.sync="dialogGoodsList" @on-select="onSelect"></users>
    </template>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { getMedalList, sendOut } from '@/api/demo/medal/index'
import users from '../../../components/users/index.vue'
export default {
  name: 'medalManger',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    users
  },
  data () {
    return {
      medalManger_btn_add: false,
      medalManger_btn_edit: false,
      medalManger_btn_grant: false,

      multipleSelection: [], // 用户数据
      dlGoodsShow: false,
      dialogGoodsList: [], // 弹窗用户列表
      tableKey: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      form: {
        multipleSelection: []
      },
      total: null,
      medalLsit: [],
      listLoading: true, // 加载圈圈
      userID: '', //
      dialogFormVisible: false // 隐藏显示用户列表
    }
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  created () {
    this.getList()
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      let that = this
      getMedalList(that.listQuery).then(res => {
        this.listLoading = true
        that.medalLsit = res.records
        this.total = parseInt(res.total)
        this.listLoading = false
      })
    },
    // 添加勋章
    getAdd () {
      this.$router.push('./medal/addMedal')
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getList(val)
    },
    editCard (id) {
      this.$router.push({
        path: './medal/addMedal',
        query: {
          id: id
        }
      })
    },
    // 优惠券发放给特定用户
    getGrant (id) {
      this.userID = id
      console.log('ids', id, this.userID)
      this.dialogFormVisible = true
    },
    // 选择用户
    openDialog () {
      // this.indexId = index;
      this.dlGoodsShow = true
      this.dialogGoodsList = this.form.multipleSelection // 勾选回选
    },
    // 取消
    onCancel () {
      this.dialogFormVisible = false
    },
    // 确定
    onDetermine () {
      let that = this
      that.$refs.ruleForm.validate(valid => {
        if (valid) {
          let userlist = []
          for (
            let index = 0;
            index < that.form.multipleSelection.length;
            index++
          ) {
            userlist.push(that.form.multipleSelection[index].id)
          }
          console.log('userlist', userlist, that.form, that.userID)
          sendOut(that.userID, userlist).then(res => {
            that.getList()
            that.dialogFormVisible = false
            that.$notify({
              title: '成功',
              message: '发放成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    // 用户弹窗确认选择
    onSelect () {
      let that = this
      let multipleSelection = that.form.multipleSelection
      let newGoodsList = that.dialogGoodsList.filter(
        item => !multipleSelection.some(ele => ele.id === item.id)
      ) // 新数组
      multipleSelection = [...multipleSelection, ...newGoodsList] // 商品
      that.form.multipleSelection = multipleSelection
      // console.log("multipleSelection" );
      // console.log("dialogGoodsList", that.dialogGoodsList);
    },
    closedFn () {
      this.$refs.ruleForm.clearValidate()
    },
    // 用户批量删除
    async batchDelete () {
      let that = this
      if (!that.$refs.tableRef.selection.length) {
        that.$message.error('请勾选要删除的用户')
        return
      }
      for (var i = that.$refs.tableRef.selection.length - 1; i >= 0; i--) {
        console.log('i', i)
        that.form.multipleSelection.splice(i, 1)
      }
    }
  }
}
</script>

<style scoped>
</style>
